<template>
  <v-card width="100%">
    <v-container fluid>
      <v-row class="ma-0" align="center">
        <v-col cols="3">
          <v-autocomplete
            v-model="lazyItem.nmProdutor"
            label="Produtor"
            :disabled="mustDisableFields"
            :items="producers"
            item-text="nmProdutor"
            item-value="nmProdutor"
            outlined
            hide-details
          />
        </v-col>
        <v-col cols="4">
          <v-text-field
            v-model="lazyItem.strMotivo"
            label="Motivo"
            :disabled="mustDisableFields"
            outlined
            hide-details
          />
        </v-col>
        <v-col cols="3">
          <v-autocomplete
            v-model="lazyItem.cdResponsavelTecnico"
            label="Extencionista"
            :disabled="mustDisableFields"
            :items="technicalManagers"
            item-text="nmPessoa"
            item-value="idResponsavelTecnico"
            outlined
            hide-details
          />
        </v-col>
        <v-col cols="2">
          <v-row class="ma-0" align="center" justify="end">
            <v-btn
              v-if="showSaveBtn"
              fab
              small
              color="#10303d"
              class="mx-1 white--text"
              @click="onSaveClick"
              :loading="isLoading"
            >
              <v-icon>mdi-content-save</v-icon>
            </v-btn>
            <v-btn
              v-if="showEditBtn"
              fab
              small
              color="#10303d"
              class="mx-1 white--text"
              @click="onEditClick"
              :loading="isLoading"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              fab
              small
              color="error"
              class="mx-1"
              @click="onDeleteClick"
              :loading="isLoading"
            >
              <v-icon>mdi-trash-can</v-icon>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { URLS } from "@/modules/ProducersWithoutAccess/api/urls";
import { cloneDeep } from "lodash/lang";

export default {
  name: "ProducerWithoutAccessItem",
  props: {
    index: {
      type: Number,
      required: true,
    },
    item: {
      type: Object,
      required: true,
    },
    producers: {
      type: Array,
      required: true,
    },
    technicalManagers: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    isEditing: false,
    lazyItem: {
      idProdutorSemAcesso: null,
      nmProdutor: null,
      strMotivo: null,
      cdResponsavelTecnico: null,
    },

    isLoading: false,
  }),
  methods: {
    onSaveClick() {
      const toSave = {
        index: this.index,
        item: this.lazyItem,
      };

      const payload = {
        nmProdutor: this.lazyItem.nmProdutor,
        strMotivo: this.lazyItem.strMotivo,
        cdResponsavelTecnico: this.lazyItem.cdResponsavelTecnico,
      };

      this.isLoading = true;
      if (this.item.idProdutorSemAcesso) {
        const finalUrl = `${URLS.PRODUCERS_WITHOUT_ACCESS}${this.lazyItem.idProdutorSemAcesso}`;
        this.$axios
          .put(finalUrl, payload)
          .then((res) => {
            if (!res.data) return;
            if (!res.data[0]) return;
            if (!res.data[0].data) return;
            this.lazyItem = res.data[0].data;
            delete this.lazyItem["cdEmpresa"];
            toSave.item = cloneDeep(this.lazyItem);
            this.isEditing = false;
            this.$emit("save", toSave);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$axios
          .post(URLS.PRODUCERS_WITHOUT_ACCESS, payload)
          .then((res) => {
            if (!res.data) return;
            if (!res.data[0]) return;
            if (!res.data[0].data) return;
            const data = res.data[0].data;
            this.lazyItem.idProdutorSemAcesso = data.idProdutorSemAcesso;
            toSave.item = cloneDeep(this.lazyItem);
            this.$emit("save", toSave);
          })
          .finally(() => (this.isLoading = false));
      }
    },
    onEditClick() {
      this.isEditing = true;
    },
    onDeleteClick() {
      const toDelete = {
        index: this.index,
        item: this.lazyItem,
      };

      if (this.item.idProdutorSemAcesso) {
        this.isLoading = true;
        const finalUrl = `${URLS.PRODUCERS_WITHOUT_ACCESS}${this.lazyItem.idProdutorSemAcesso}`;
        this.$axios
          .delete(finalUrl)
          .then(() => {
            this.$emit("delete", toDelete);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$emit("delete", toDelete);
      }
    },
  },
  computed: {
    showSaveBtn() {
      if (this.item.idProdutorSemAcesso === null) return true;
      return this.isEditing;
    },
    showEditBtn() {
      if (this.item.idProdutorSemAcesso === null) return false;
      return !this.isEditing;
    },
    mustDisableFields() {
      if (this.item.idProdutorSemAcesso === null) return false;
      return !this.isEditing;
    },
  },
  watch: {
    item: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.lazyItem = newValue;
      },
    },
  },
};
</script>

<style scoped></style>
